import { SkuSummary } from './sku-summary'

export class SkuConstraint {
  constructor(public summary: SkuSummary) {}

  get isValid(): boolean {
    return this.isCountValid
  }

  get isCountValid(): boolean {
    return this.summary.selection.count <= this.summary.maxCount
  }
}
